<template>
    <div>
        <NavBar></NavBar>
        <div class="row">
            <MarketWatch class="col-md-4 d-none d-md-block"></MarketWatch>
            <div class="col-md-8">
                <div class="profile-container">
                    <div class="page-header">
                        <h4 class="page-title">Profile</h4>
                    </div>

                    <!-- User Profile Card -->
                    <div class="profile-card">
                        <div class="profile-header">
                            <div class="avatar">
                                <i class="bi bi-person-circle"></i>
                            </div>
                            <div class="user-info">
                                <h5 class="user-name">{{ $store.state.user.firstName }} {{ $store.state.user.lastName }}</h5>
                                <p class="user-email">{{ $store.state.user.emailId }}</p>
                            </div>
                        </div>
                        <div class="profile-details">
                            <div class="detail-item">
                                <i class="bi bi-telephone"></i>
                                <div class="detail-content">
                                    <span class="detail-label">Phone</span>
                                    <span class="detail-value">{{ $store.state.user.phoneNumber || 'Not provided' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <i class="bi bi-percent"></i>
                                <div class="detail-content">
                                    <span class="detail-label">Brokerage</span>
                                    <span class="detail-value">{{ $store.state.user.brokerage }} &#8377;</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Funds Card -->
                    <div class="funds-card">
                        <div class="card-title-row">
                            <i class="bi bi-wallet2"></i>
                            <h5>Funds Overview</h5>
                        </div>
                        <div class="funds-grid">
                            <div class="fund-item total">
                                <span class="fund-label">Total Virtual Money</span>
                                <span class="fund-value">&#8377; {{ $store.state.user.virtualMoney ? $store.state.user.virtualMoney.toLocaleString('en-IN') : 0 }}</span>
                            </div>
                            <div class="fund-item blocked">
                                <span class="fund-label">Blocked</span>
                                <span class="fund-value">&#8377; {{ $store.state.user.virtualMoneyBlocked ? $store.state.user.virtualMoneyBlocked.toLocaleString('en-IN') : 0 }}</span>
                            </div>
                            <div class="fund-item available">
                                <span class="fund-label">Available</span>
                                <span class="fund-value highlight">&#8377; {{ $store.state.user.virtualMoneyLeft ? $store.state.user.virtualMoneyLeft.toLocaleString('en-IN') : 0 }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Settings Card -->
                    <div class="settings-card">
                        <div class="card-title-row">
                            <i class="bi bi-gear"></i>
                            <h5>Settings</h5>
                        </div>
                        <div class="settings-list">
                            <div class="setting-item" @click="otpModal = true">
                                <div class="setting-left">
                                    <i class="bi bi-key"></i>
                                    <span>Change Password</span>
                                </div>
                                <i class="bi bi-chevron-right"></i>
                            </div>
                            <div class="setting-item" @click="$store.commit('setVirtualMoney', true)">
                                <div class="setting-left">
                                    <i class="bi bi-cash-stack"></i>
                                    <span>Set Virtual Money</span>
                                </div>
                                <i class="bi bi-chevron-right"></i>
                            </div>
                            <div class="setting-item" @click="$store.commit('setClearHistory', true)">
                                <div class="setting-left">
                                    <i class="bi bi-trash"></i>
                                    <span>Clear History</span>
                                </div>
                                <i class="bi bi-chevron-right"></i>
                            </div>
                            <div class="setting-item" @click="toggleDarkMode" v-if="showDarkModeToggle">
                                <div class="setting-left">
                                    <i :class="$store.state.darkMode ? 'bi bi-sun' : 'bi bi-moon'"></i>
                                    <span>{{ $store.state.darkMode ? 'Light Mode' : 'Dark Mode' }}</span>
                                </div>
                                <div class="toggle-switch" :class="{ active: $store.state.darkMode }">
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-overlay" v-if="otpModal" @click.self="otpModal = false; errorMsg2 =''; otp = ''">
            <div class="modal-container">
                <div class="modal-content w-60">
                    <div class="modal-header">
                        <h5 class="modal-title" id="otpModalLabel">Change Password</h5>
                        <button type="button" class="btn-close" @click="otpModal = false; errorMsg2 =''; otp = ''"  aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form onsubmit="return false;">
                            <div class="mb-3">
                                <label for="password1" class="form-label">Old Password</label>
                                <input v-model="oldPassword" type="password" class="form-control" id="password1" placeholder="Enter your old password" required>
                            </div>
                            <div class="mb-3">
                                <label for="password2" class="form-label">New Password</label>
                                <input v-model="newPassword" type="password" class="form-control" id="password2" placeholder="Enter your new password" required>
                            </div>
                            <div class="mb-3">
                                <label for="password3" class="form-label">Confirm Password</label>
                                <input v-model="confirmPassword" type="text" class="form-control" id="password3" placeholder="Enter your confirm password" required>
                            </div>
                            <button class="btn btn-primary w-100" @click="changePassword">Change Password</button>
                            <p class="form-label mt-3" style="color:red;" v-if="errorMsg2 && errorMsg2 !== 'Password Changed Successfully'">{{ errorMsg2 }}</p>
                            <p class="form-label mt-3" style="color:green;" v-if="errorMsg2 === 'Password Changed Successfully'">{{ errorMsg2 }}</p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NavBar from '@/components/main/NavBar.vue'
import MarketWatch from '@/components/marketwatch/MarketWatch'
import { changePassword } from '@/service/restService'

export default {
  name: 'Profile',
  components: {
    NavBar,
    MarketWatch
  },
  data () {
    return {
      otpModal: false,
      oldPassword: '',
      newPassword: '',
      errorMsg2: '',
      confirmPassword: '',
      virtualMoney: false,
      showDarkModeToggle: false
    }
  },
  created () {
    this.getUserView()
    this.showDarkModeToggle = !this.isWebView() || (this.isWebView() && this.getVersion() >= 5)
  },
  methods: {
    toggleDarkMode () {
      const newDarkMode = !this.$store.state.darkMode
      this.$store.commit('setDarkMode', newDarkMode)
      if (newDarkMode) {
        this.triggerAndroidFunction('DARKMODE')
      } else {
        this.triggerAndroidFunction('WHITEMODE')
      }
    },
    changePassword: function () {
      if (!this.oldPassword) {
        this.errorMsg2 = 'Please enter your old password'
        return
      }
      if (this.oldPassword.length < 6) {
        this.errorMsg2 = '"Your old password needs to be between 6 and 20 characters long'
        return
      }
      if (!this.newPassword) {
        this.errorMsg2 = 'Please enter your new password'
        return
      }
      if (this.newPassword.length < 6) {
        this.errorMsg2 = '"Your new password needs to be between 6 and 20 characters long'
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorMsg2 = 'Your new password does not match with confirmed Password'
        return
      }
      var obj = { newPassword: this.newPassword, oldPassword: this.oldPassword }
      this.errorMsg2 = ''
      changePassword(obj).then((response) => {
        this.errorMsg2 = 'Password Changed Successfully'
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    }

  }
}
</script>

<style scoped>
.profile-container {
  padding: 20px;
  max-width: 600px;
}

.page-header {
  margin-bottom: 20px;
}

.page-title {
  font-weight: 600;
  color: var(--bs-body-color);
  margin: 0;
}

/* Profile Card */
.profile-card {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--bs-border-color);
  margin-bottom: 16px;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0d6efd, #6610f2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar i {
  font-size: 36px;
  color: white;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: var(--bs-body-color);
}

.user-email {
  font-size: 14px;
  color: var(--bs-secondary-color);
  margin: 0;
  word-break: break-all;
}

.profile-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.detail-item > i {
  font-size: 18px;
  color: var(--bs-secondary-color);
  width: 24px;
  text-align: center;
}

.detail-content {
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--bs-body-color);
}

/* Funds Card */
.funds-card {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.card-title-row i {
  font-size: 20px;
  color: var(--bs-primary);
}

.card-title-row h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.funds-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.fund-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--bs-tertiary-bg);
}

.fund-label {
  font-size: 13px;
  color: var(--bs-secondary-color);
}

.fund-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.fund-value.highlight {
  color: #0BDA51;
}

/* Settings Card */
.settings-card {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.settings-list {
  display: flex;
  flex-direction: column;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid var(--bs-border-color);
  cursor: pointer;
  transition: background-color 0.2s;
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-item:hover {
  background-color: var(--bs-tertiary-bg);
  margin: 0 -20px;
  padding: 14px 20px;
}

.setting-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.setting-left i {
  font-size: 18px;
  color: var(--bs-secondary-color);
  width: 24px;
  text-align: center;
}

.setting-left span {
  font-size: 14px;
  color: var(--bs-body-color);
}

.setting-item > i {
  color: var(--bs-secondary-color);
  font-size: 14px;
}

/* Toggle Switch */
.toggle-switch {
  width: 44px;
  height: 24px;
  background: var(--bs-secondary-bg);
  border-radius: 12px;
  position: relative;
  transition: background-color 0.3s;
}

.toggle-switch.active {
  background: #0d6efd;
}

.toggle-knob {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-switch.active .toggle-knob {
  transform: translateX(20px);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background-color: var(--bs-body-bg);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  padding: 20px;
}

.modal-content {
  border: none;
  background-color: var(--bs-body-bg);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .profile-container {
    padding: 15px;
  }

  .profile-header {
    flex-direction: column;
    text-align: center;
  }

  .avatar {
    width: 80px;
    height: 80px;
  }

  .avatar i {
    font-size: 44px;
  }

  .user-info {
    text-align: center;
  }

  .funds-grid {
    grid-template-columns: 1fr;
  }

  .setting-item:hover {
    margin: 0;
    padding: 14px 0;
    background-color: transparent;
  }
}

/* Desktop - larger screens */
@media (min-width: 992px) {
  .funds-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .fund-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.pointer { cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue